(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ap-product-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const guideSelector = '[data-ap-product-guide]';

    function createGuide(step, text, type) {
      const guide = document.createElement('aside');
      const number = document.createElement('span');
      const content = document.createElement('span');
      const arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      const curve = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      const arrowhead = document.createElementNS('http://www.w3.org/2000/svg', 'path');

      guide.className = `ap-selection-guide ap-selection-guide--${type}`;
      guide.setAttribute('aria-live', 'polite');
      number.className = 'ap-selection-guide__number';
      number.setAttribute('aria-hidden', 'true');
      number.textContent = step;
      content.textContent = text;
      arrow.classList.add('ap-selection-guide__arrow');
      arrow.setAttribute('viewBox', '0 0 48 34');
      arrow.setAttribute('aria-hidden', 'true');
      curve.setAttribute('d', 'M43 4C28 4 27 27 9 27');
      arrowhead.setAttribute('d', 'M16 19 8 27l10 3');
      arrow.append(curve, arrowhead);
      guide.append(number, content, arrow);

      return guide;
    }

    function findTarget(input, label) {
      let target = input.parentElement;

      for (let level = 0; target && level < 7; level += 1, target = target.parentElement) {
        if ((target.innerText || '').includes(label)) return target;
      }

      return input.parentElement;
    }

    function dismiss(guide) {
      if (!guide || guide.dataset.dismissed === 'true') return;

      guide.dataset.dismissed = 'true';
      window.setTimeout(() => guide.remove(), 220);
    }

    function mountGuide(mount) {
      if (mount.dataset.ready === 'true') return;

      mount.dataset.ready = 'true';
      const product = mount.closest('.product-details') || document.querySelector('.product-details') || document.querySelector('main');
      if (!product) return;

      const observer = new MutationObserver(setup);

      function setup() {
        const radios = product.querySelectorAll('input[type="radio"]');
        const fileInput = product.querySelector('input[type="file"]');

        if (!radios.length || !fileInput) return;

        const colorTarget = findTarget(radios[0], mount.dataset.colorLabel);
        const uploadTarget = findTarget(fileInput, mount.dataset.uploadLabel);
        const colorGuide = createGuide('1', mount.dataset.colorText, 'color');
        const uploadGuide = createGuide('2', mount.dataset.uploadText, 'upload');

        colorTarget.classList.add('ap-selection-guide-target');
        uploadTarget.classList.add('ap-selection-guide-target');
        colorTarget.append(colorGuide);
        uploadTarget.append(uploadGuide);
        observer.disconnect();
        mount.remove();

        radios.forEach((radio) => {
          radio.addEventListener('change', () => dismiss(colorGuide), { once: true });
          radio.addEventListener('click', () => dismiss(colorGuide), { once: true });
        });

        fileInput.addEventListener('click', () => dismiss(uploadGuide), { once: true });
        fileInput.addEventListener('change', () => dismiss(uploadGuide), { once: true });
      }

      setup();
      if (mount.isConnected) {
        observer.observe(product, { childList: true, subtree: true });
        window.setTimeout(() => observer.disconnect(), 5000);
      }
    }

    function initialize(scope = document) {
      scope.querySelectorAll(guideSelector).forEach(mountGuide);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
